import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";

export const DeploymentAccountGroupsLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action='ListDeploymentAccountGroups' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action='GetDeploymentAccountGroup' redirectTo='/deployment-account-groups'>
                        <EditPage/>
                    </RequirePermission>
                }

            >
            </Route>


        </Routes>
    );
};
